// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default class EmailInput extends Component {

  static defaultProps = {
    readOnly: false,

    required: false,

    onBlur: () => {},

    error: false,
  };

  static propTypes = {
    value: PropTypes.string,

    placeholder: PropTypes.string,

    /**
     * @param number The phone number
     */
    onChange: PropTypes.func.isRequired,

    onBlur: PropTypes.func,

    className: PropTypes.string,

    readOnly: PropTypes.bool,

    required: PropTypes.bool,

    error: PropTypes.bool,
  };

  render() {
    const className = classNames('form-control', this.props.className, {
      error: this.props.error,
    });

    return (
      <input
        type="email"
        onChange={(event) => { this.props.onChange(event.target.value); }}
        onBlur={this.props.onBlur}
        placeholder={this.props.placeholder}
        value={this.props.value || ''}
        className={className}
        disabled={this.props.readOnly}
      />
    );
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/EmailInput.js